var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#10b2fd",
      fillOpacity: 1,
      strokeWidth: 6.57717,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path2",
    cx: 60.080231,
    cy: 60.134243,
    rx: 59.595203,
    ry: 59.875904
  }), /*#__PURE__*/React.createElement("g", {
    id: "g11",
    transform: "matrix(0.96928149,0,0,0.97384694,3.5662345,1.0676119)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 5.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    id: "rect3",
    width: 81.180824,
    height: 57.560974,
    x: 17.268291,
    y: 29.57443
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3",
    cx: 35.330528,
    cy: 45.651806,
    rx: 9.9326687,
    ry: 9.7341833
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 34.807018,36.491228 34.666667,46.596491 45.473684,46.315789",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 24,59.368421 H 45.614035",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 23.865789,63.427194 H 45.479824",
    id: "path5-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 23.865789,67.602633 H 45.479824",
    id: "path5-6"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect5",
    width: 5.6140351,
    height: 14.315789,
    x: 54.175438,
    y: 55.017544
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect6",
    width: 6.5964913,
    height: 23.719297,
    x: 63.719299,
    y: 46.035088
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect7",
    width: 6.877193,
    height: 16.280703,
    x: 74.385963,
    y: 53.473682
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect8",
    width: 5.8947368,
    height: 19.649122,
    x: 85.333336,
    y: 49.964912
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 54.315789,47.578947 11.929825,-10.105263 11.929825,8.701755 12.631579,-8",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 17.824561,74.666667 79.017544,0.140351",
    id: "path9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path10",
    cx: 58.035088,
    cy: 80.280701,
    rx: 1.7539999,
    ry: 1.6842105
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect10",
    width: 18.245613,
    height: 3.3684211,
    x: 48.561405,
    y: 88.561401
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect11",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 42.159268,91.912796 h 31.42278 l 1.786375,4.929306 H 39.777435 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.672868c30068192425bd2172098961f8.svg";
export { ForwardRef as ReactComponent };